export default __webpack_public_path__ + "static/media/boton-multipagos.2f19c68c.png";